import { Directive, OnDestroy, OnInit } from '@angular/core';
// import { MatDialog } from '@angular/material/dialog';
// import { MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { EventOrderList } from 'src/modules/event/components/order-list/component';
import { DateRange } from 'src/modules/event/interfaces/date-range';
// import { Event } from 'src/modules/event/interfaces/event';
// import { OrderApiService } from 'src/modules/order/services/order-api-service';
// import { OrderDataSource } from 'src/modules/order/services/order-data-source';
import { ApiService } from 'src/app/services/api.service';
import moment from 'moment';
import { Subscription } from 'rxjs';
import Base = moment.unitOfTime.Base;
import { endpoints } from 'src/app/constants/endpoints';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Directive({
    standalone: false
})
export abstract class Dashlet implements OnInit, OnDestroy {
  public abstract paginator: MatPaginator;

  protected abstract endpoint: string;
  protected abstract role: string;

  public leisureUrl: string = environment.leisureUrl;
  public listResults;
  public dataSource: any;
  public loading: boolean;

  public dateSize = 'week' as Base;

  public DateRange: DateRange;

  public totalUsers: number;
  public newUsers: number;

  public pageSize = 10;
  public currentPage = 0;
  public totalSize = 0;

  protected Subscriptions: Subscription[] = [];

  protected abstract Api: ApiService;
  protected abstract commonFunctionService: CommonFunctionService;
  // protected abstract OrderApi: OrderApiService;
  // protected abstract Dialog: MatDialog;

  ngOnInit() {
    this.setDateSize(this.dateSize);
  }

  public initDashlet() {
    this.loading = true;
    this.list()
      .then((response) => this.initPage(response))
      .finally(() => (this.loading = false));
  }

  public list() {
    return new Promise((resolve, reject) => {
      let endpoint = `${this.endpoint}`;
      endpoint = this.addDateRangeToEndpoint(endpoint, this.DateRange);
      if (endpoint.split('/')[1] !== 'new-users') {
        endpoint = this.addPaginationToEndpoint(endpoint);
      }

      const url = this.commonFunctionService.findApiUrl(this.role);

      setTimeout(() =>
        this.Api.get(endpoint, url).then(
          (result: string) => resolve(result),
          (error) => reject(error)
        )
      );
    });
  }

  public initPage(response: any) {
    const { data, pageEvent } = response;
    if (this.endpoint.split('/')[1] === endpoints.user.newUsers.split('/')[1]) {
      this.listResults = data['new'];
      this.newUsers = data['newCount'];
      this.totalUsers = data['total'];
    } else {
      this.listResults = data;
    }

    this.dataSource = new MatTableDataSource(this.listResults);
    this.totalSize = pageEvent.length.count;
  }

  public handlePage(e: PageEvent) {
    this.currentPage = e.pageIndex;
    this.initDashlet();
    return e;
  }

  //   public guestList(Event: Event) {
  //     const config = new MatDialogConfig();
  //     config.disableClose = true;

  //     const DataSource = new OrderDataSource(
  //       {
  //         role: 'eventAdmin',
  //         eventId: Event.id,
  //       },
  //       this.OrderApi
  //     );

  //     const title = Event.listingTitle;
  //     const Item = Event;

  //     config.data = {
  //       title,
  //       Item,
  //       DataSource,
  //     };

  //     this.Subscriptions.push(
  //       this.Dialog.open(EventOrderList, config)
  //         .afterClosed()
  //         .subscribe(ticketId => !!ticketId)
  //     );
  //   }

  public setDateSize(dateSize: any) {
    const startDate = this.DateRange ? this.DateRange.startDate : new Date();

    this.dateSize = dateSize;
    this.setDateRange(startDate);
    this.initDashlet();
  }

  public incrementStartDate() {
    const startDate = this.DateRange ? this.DateRange.startDate : new Date();

    this.setDateRange(moment(startDate).add(1, this.dateSize).toDate());

    this.initDashlet();
  }

  public decrementStartDate() {
    const startDate = this.DateRange ? this.DateRange.startDate : new Date();

    this.setDateRange(moment(startDate).subtract(1, this.dateSize).toDate());

    this.initDashlet();
  }

  public startDateToday() {
    this.setDateRange(new Date());
    this.initDashlet();
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((item) => item.unsubscribe());
  }

  private setDateRange(startDate: Date) {
    this.DateRange = {
      startDate: moment(startDate).startOf(this.dateSize).toDate(),
      endDate:
        'day' !== this.dateSize
          ? moment(startDate).endOf(this.dateSize).toDate()
          : moment(startDate).toDate(),
    };
    this.currentPage = 0;
  }

  private addDateRangeToEndpoint(endpoint: string, DateRange?: DateRange) {
    const startDate = DateRange
      ? moment(DateRange.startDate).format('YYYY-MM-DD')
      : null;
    const endDate =
      !!DateRange &&
      !!DateRange.endDate &&
      DateRange.startDate !== DateRange.endDate
        ? moment(DateRange.endDate).format('YYYY-MM-DD')
        : null;
    !!startDate && (endpoint += `/start-date/${startDate}`);
    !!endDate && (endpoint += `/end-date/${endDate}`);

    return endpoint;
  }
  private addPaginationToEndpoint(endpoint: string) {
    return (
      endpoint +
      '/page-size/' +
      this.pageSize +
      '/page-index/' +
      this.currentPage
    );
  }
}
